export const GET_INTERNAL_REPORTS_STATS= 'GET_INTERNAL_REPORTS_STATS';
export const GET_INTERNAL_REPORTS_STATS_ERR = 'GET_INTERNAL_REPORTS_STATS_ERR';
export const GET_EXTERNAL_REPORTS_STATS= 'GET_EXTERNAL_REPORTS_STATS';
export const GET_EXTERNAL_REPORTS_STATS_ERR = 'GET_EXTERNAL_REPORTS_STATS_ERR';
export const GET_QC_DASHBOARD_COUNT= 'GET_QC_DASHBOARD_COUNT';
export const GET_QC_DASHBOARD_COUNT_ERR = 'GET_QC_DASHBOARD_COUNT_ERR';
export const GET_QC_DOWNLOAD = 'GET_QC_DOWNLOAD'
export const GET_QC_DOWNLOAD_ERR = 'GET_QC_DOWNLOAD_ERR'